import React, { useState, useEffect } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { formatTaiwanDate } from '../../../utils';
import { EditOrderModalList } from '../../../constants';

import { getDeliverOrders } from '../../../service/api/StaffOrder/apiStaffOrder';

const EditOrderModal = ({ order, onClose, onSave, onChange }) => {
  const [deliverOrdersData, setDeliverOrdersData] = useState([]);

  useEffect(() => {
    getDeliverOrders({type: 'afterToday'})
      .then(response => {
        if (response?.status === 200) {
          setDeliverOrdersData(response.data.result);
        }
      });
  }, []);

  return (
    <form>
      <div className="custom-modal-backdrop">
        <div className="custom-modal">
          <div className="custom-modal-header">
            <h5 className="modal-title">編輯訂單 {order?.number}</h5>
            <button className="btn-close" onClick={(e) => { onClose(null); e.preventDefault(); }}></button>
          </div>

          <div className="custom-modal-body">
            {/* 基本資訊 */}
            {EditOrderModalList.map(field => (
              <div className="input-group mb-3" key={field.key}>
                <span className="input-group-text">
                  {field.label}
                  {field.required && <span className="required-star">*</span>}
                </span>
                <input
                  type={field.type || "text"}
                  className="form-control"
                  value={field.value === 'deliveryDate' ? formatTaiwanDate(order?.[field.value]) : order?.[field.value]}
                  placeholder={field.placeholder}
                  onChange={e => onChange({ ...order, [field.key]: e.target.value })}
                />
              </div>
            ))}

            {/* 出貨狀態 */}
            <div className="input-group mb-3">
              <span className="input-group-text">寄送狀態</span>
              <select
                className="form-select"
                value={order?.isShipped ? "shipped" : "pending"}
                onChange={e => onChange({ ...order, isShipped: e.target.value === "shipped" })}
              >
                <option value="pending">未送達</option>
                <option value="shipped">已送達</option>
              </select>
            </div>

            {/* 審核狀態 */}
            <div className="input-group mb-3">
              <span className="input-group-text">審核狀態</span>
              <select
                className="form-select"
                value={order?.status === 1 ? "approved" : order?.status === 0 ? "unReviewed" : "rejected"}
                onChange={e => onChange(prev => ({ ...prev, status: e.target.value === "approved" ? 1 : e.target.value === "unReviewed" ? 0 : 2 }))}
              >
                <option value="rejected">未通過</option>
                <option value="unReviewed">未審核</option>
                <option value="approved">已通過</option>
              </select>
            </div>

            {/* 樓層服務 */}
            <div className="input-group mb-3">
              <span className="input-group-text">樓層服務</span>
              <select
                className="form-select"
                value={Number(order?.hasFloorService) ? 1 : 0}
                onChange={e => onChange(prev => ({ ...prev, hasFloorService: e.target.value }))}
              >
                <option value="0">否</option>
                <option value="1">是</option>
              </select>
            </div>

            {/* 選擇送貨單 */}
            <div className="input-group mb-3">
              <span className="input-group-text">送貨單</span>
              <select
                className="form-select"
                value={order?.deliverOrderId || ""}
                onChange={e => onChange({ ...order, deliverOrderId: e.target.value })}
              >
                <option value="">-- 請選擇送貨單 --</option>
                {deliverOrdersData.map(deliverOrder => (
                  <option key={deliverOrder.id} value={deliverOrder.id}>
                    ID:{deliverOrder.id} {deliverOrder.name} ({deliverOrder.plate})
                  </option>
                ))}
              </select>
            </div>

          </div>

          <div className="custom-modal-footer">

            <div className="form-check form-switch">
              {/* ✅ 是否寄送 Email */}
              <input
                className="form-check-input"
                type="checkbox"
                id="sendEmail"
                name="sendEmail"
                value={false}
                onChange={e => onChange({ ...order, sendEmail: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="sendEmail">
                是否傳送 Email
              </label>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-secondary" onClick={(e) => { onClose(null); e.preventDefault(); }}>取消</button>
              <button className="btn btn-gradient-primary" type="button" onClick={() => onSave(order)}>儲存</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export { EditOrderModal };
